import { IoAddCircleOutline } from 'react-icons/io5';
import { Search } from '../../../../components';
import { Options, Selected } from '../../styled';
import ListItem from '../ListItem';
import SelectedItem from '../SelectedItem';
import SkeletonLoader from '../SkeletonLoader';

const ListsStep = ({
    lists,
    listsSelected,
    searchInList,
    setSearchInList,
    onSelectList,
    onRemoveList,
    onNewList,
    loading,
    onFilterList,
    allowCreateList
}) => {
    return (
        <div className="content">
            <div className='box--y'>
                <span className='add--'>
                    {allowCreateList && (
                        <span onClick={onNewList}>
                            nova lista
                            <IoAddCircleOutline />
                        </span>
                    )}
                </span>
                <Search
                    className='search--'
                    value={searchInList}
                    onChange={(e) => setSearchInList(e.target.value)}
                />
                <Options>
                    {loading ? (
                        <SkeletonLoader count={15} />
                    ) : (
                        <>
                            {lists?.length > 0 &&
                                lists?.filter(onFilterList).map((item) => (
                                    <ListItem
                                        key={item.id}
                                        item={item}
                                        onClick={onSelectList}
                                    />
                                ))
                            }
                        </>
                    )}
                </Options>
            </div>
            <div className='box--y'>
                <span className='tag--'>
                    <label>Selecionadas :</label>
                </span>
                <Selected>
                    {listsSelected?.length > 0 &&
                        listsSelected?.map((item) => (
                            <SelectedItem
                                key={item.id}
                                item={item}
                                type="list"
                                onRemove={onRemoveList}
                            />
                        ))
                    }
                </Selected>
            </div>
        </div>
    );
};

export default ListsStep;